import gql from 'graphql-tag'

export const COURSE_ADD_VIDEO = gql`
  mutation academyCourseAddVideo($courseId: Int!, $mediaId: Int!, $transcript: String) {
    academyCourseAddVideo(courseId: $courseId, mediaId: $mediaId, transcript: $transcript) {
      id
      courseMedias {
        id
        media {
          thumbnail
          source
          url
          fileName
          id
          status
        }
        transcript
      }
    }
  }
`

export const COURSE_UPDATE_VIDEO = gql`
  mutation academyCourseUpdateVideo($courseId: Int!, $mediaId: Int!, $transcript: String!) {
    academyCourseUpdateVideo(courseId: $courseId, mediaId: $mediaId, transcript: $transcript) {
      id
      courseMedias {
        id
        media {
          thumbnail
          source
          url
          fileName
          id
          status
        }
        transcript
      }
    }
  }
`

export const COURSE_REMOVE_VIDEOS = gql`
  mutation academyCourseRemoveVideos($courseId: Int!, $mediaIds: [Int]) {
    academyCourseRemoveVideos(courseId: $courseId, mediaIds: $mediaIds) {
      id
      courseMedias {
        id
        media {
          thumbnail
          source
          url
          fileName
          id
          status
        }
        transcript
      }
    }
  }
`
